import { stylesheet } from 'typestyle';
import { Blue10, Blue80 } from '@traceair/tds';
import { UploadValidationStatus } from '../../../../../../consts/uploadValidationStatus';
import { getUploadValidationStatusColors } from '../../../helpers/uploadValidation';

const css = stylesheet({
  container: {
    marginTop: 8,
    height: 3,
    borderRadius: 5,
    overflow: 'hidden',
    background: Blue10,
  },
  indicator: {
    height: '100%',
    borderRadius: 5,
    background: Blue80,
  },
});

interface Props {
  progress: number;
  status: UploadValidationStatus;
}

export const FlightValidationProgressBar = ({ progress, status }: Props) => {
  const roundedProgress = Math.round(progress);
  const colors = getUploadValidationStatusColors(status);

  return (
    <div className={css.container} style={{ background: colors.secondary }}>
      <div className={css.indicator} style={{ width: `${roundedProgress}%`, background: colors.primary }} />
    </div>
  );
};
